import styled from 'styled-components'

import { ZoneType } from '@types'

export const WrappedComponentContainer = styled.div`
  position: relative;
`

export const CheckedCircle = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;

  width: 16px;
  height: 16px;

  border-radius: 50%;

  background-color: var(--Foreground-Primary, #4d4be7);
`

export const ItemContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`

export const Img = styled.img<{ type: ZoneType }>`
  width: 16px;
  height: 16px;
  padding-left: ${({ type }) => (type === ZoneType.Zone || type === ZoneType.Floor ? '12px' : '0')};
`

export const IconContainer = styled.div`
  display: none;
  align-items: center;
  justify-content: center;

  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--Background-Primary, #5a58f2);

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    display: flex;
  }
`

export const SelectedItemLabel = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex: 1;
    color: var(--Foreground-Neutral, #14171f);

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const ItemLabel = styled.div<{ selected?: boolean }>`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex: 1;

    color: ${({ selected }) =>
      selected
        ? 'var(--Foreground-Primary, var(--Foreground-Primary, #4D4BE7))'
        : 'var(--Foreground-Neutral, #14171f)'};

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`
